/**
 * Automatic booking of supplier invoices: the settings card's logic
 * (automation-by-entitlement SPEC D3, D9). Activation is the entitlement and
 * the kill switch; the card manages the cap only. An empty cap means the
 * product default, which the response carries as defaultCap.
 */
export const AUTO_BOOKING_EXPLANATION =
  'Fakturor från inkorgen under beloppsgränsen från kända leverantörer bokförs automatiskt. Allt annat väntar på godkännande som tidigare.';

const CAP_ERROR = 'Beloppsgränsen måste vara ett positivt tal.';

/** Administrators with both entitlements, nobody else. */
export function canManageAutoBooking({ features, isAdmin }) {
  return Boolean(isAdmin && features?.auto_post && features?.periodisering);
}

/** A cap typed in kronor: spaces as thousands, comma or dot as decimals, "kr" tolerated; empty is no cap. */
export function parseCap(text) {
  const trimmed = String(text ?? '').replace(/kr/i, '').trim();
  if (!trimmed) return { amountCap: null, error: null };
  const normalised = trimmed.replace(/\s/g, '').replace(',', '.');
  if (!/^\d+(\.\d+)?$/.test(normalised)) return { amountCap: null, error: CAP_ERROR };
  const amountCap = Number(normalised);
  if (!(amountCap > 0)) return { amountCap: null, error: CAP_ERROR };
  return { amountCap, error: null };
}

export function formatCap(amountCap) {
  return amountCap == null ? '' : Number(amountCap).toLocaleString('sv-SE', { maximumFractionDigits: 2 }).replace(/ /g, ' ');
}

export function autoBookingPayload({ capText }) {
  const { amountCap, error } = parseCap(capText);
  if (error) return { payload: null, error };
  return { payload: { amountCap }, error: null };
}

/**
 * The policy's state in one sentence: on with the effective cap, or paused by
 * the kill switch. The card is only shown with both entitlements, so a
 * not-entitled response is unreachable; it reads as paused rather than on.
 */
export function autoBookingStatus({ amountCap, killSwitch, entitled, active }) {
  if (killSwitch || !entitled || !active) return 'Pausad via nödstoppet under Automatisering.';
  return `Automatisk bokföring är på (gräns ${formatCap(amountCap)} kr).`;
}
